import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface EjectErrorChromeProps {
  children: React.ReactNode;
  onGoHome?: () => void;
}

const EjectErrorChrome: React.FC<EjectErrorChromeProps> = ({ children, onGoHome }) => {
  return (
    <div
      data-testid="error-eject"
      className="relative flex min-h-screen items-center justify-center overflow-hidden px-4"
    >
      <div className="relative z-10 w-full max-w-md animate-page-in">
        <Card className="border border-white/60 bg-white/90 shadow-xl shadow-primary/10 backdrop-blur-2xl">
          <CardContent className="p-8 pt-10">
            <div className="mb-8 flex flex-col items-center text-center">
              <div className="mb-4">
                <img src="/steddy-star.svg" alt="Steddy AI" className="h-14 w-14" />
              </div>
            </div>
            <div className="text-center">{children}</div>
            <div className="mt-8 flex justify-center">
              <Button asChild variant="default">
                <Link
                  to="/"
                  replace
                  onClick={() => {
                    onGoHome?.();
                  }}
                >
                  Go home
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default EjectErrorChrome;
